
import React, { useEffect } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
} from "reactstrap";
import { FaInstagram, FaFacebookF, FaYoutube, FaWhatsapp, FaLinkedinIn, FaTwitter, FaEnvelope } from "react-icons/fa";
import { Link } from "react-router-dom";
import Footer from "components/VerticalLayout/Footer";

const Contactus = () => {
    useEffect(() => {
        // Check if the map container already exists to prevent reinitialization
        const mapContainer = document.getElementById("map");
        if (mapContainer._leaflet_id) {
            return;
        }

        // Initialize the map
        const map = L.map("map").setView([22.318952030065187, 73.14395019592004], 13); // Coordinates for Vadodara, Gujarat, India

        // Add OpenStreetMap tiles
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            maxZoom: 19,
        }).addTo(map);

        // Add a marker to the map
        L.marker([22.318952030065187, 73.14395019592004]).addTo(map).bindPopup("B/9, Ratnam Park, Gotri, Vadodara").openPopup();
    }, []);

    const phoneNumber = "+919586363303";

    // Function to generate the WhatsApp URL with the current page URL
    const generateWhatsAppLink = () => {
        const currentPageURL = window.location.href; // Get the current page URL
        const message = `Hello, I'm interested in the property listed here: ${currentPageURL}`;
        return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    };

    useEffect(() => {
        // Dynamically load the widget script
        const script = document.createElement("script");
        script.src = "https://ocpomni.alendei.io/js/widget/mzzpadohxkpzkhtr/float.js";
        script.id = "wa-widget";
        script.setAttribute("widget-id", "aaa5le"); // works as custom attribute
        script.async = true;
        document.body.appendChild(script);

        return () => {
            // Cleanup when component unmounts
            document.body.removeChild(script);
        };
    }, []);

    return (
        <React.Fragment>
            <div className="page-content" style={{ color: "#fff", fontFamily: "'Roboto', sans-serif" }}>
                <Container fluid={true} className="py-1">
                    <Row className="justify-content-center">
                        {/* Left Column: Get in Touch */}
                        <Col xl={6} lg={6} md={12}>
                            <Card
                                style={{
                                    background: "rgba(255, 255, 255, 0.1)",
                                    border: "none",
                                    borderRadius: "15px",
                                }}
                            >
                                <CardBody>
                                    <CardTitle
                                        className="mb-4 text-center"
                                        style={{ fontSize: "1.8rem", fontWeight: "600" }}
                                    >
                                        Get in Touch
                                    </CardTitle>
                                    <Form>
                                        <div className="mb-3">
                                            <Label htmlFor="formrow-name-Input">Name</Label>
                                            <Input
                                                type="text"
                                                className="form-control"
                                                id="formrow-name-Input"
                                                placeholder="Enter Your Full Name"
                                                style={{
                                                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                                                    color: "#fff",
                                                }}
                                            />
                                        </div>
                                        <Row>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-email-Input">Email</Label>
                                                    <Input
                                                        type="email"
                                                        className="form-control"
                                                        id="formrow-email-Input"
                                                        placeholder="Enter Your Email ID"
                                                        style={{
                                                            backgroundColor: "rgba(255, 255, 255, 0.2)",
                                                            color: "#fff",
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md={6}>
                                                <div className="mb-3">
                                                    <Label htmlFor="formrow-phone-Input">Phone No.</Label>
                                                    <Input
                                                        type="number"
                                                        className="form-control"
                                                        id="formrow-phone-Input"
                                                        placeholder="Phone No."
                                                        style={{
                                                            backgroundColor: "rgba(255, 255, 255, 0.2)",
                                                            color: "#fff",
                                                        }}
                                                        onKeyDown={(e) => {
                                                            // Prevents input of non-numeric keys except navigation keys
                                                            if (e.key === "e" || e.key === "+" || e.key === "-") {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                    />
                                                </div>
                                            </Col>

                                        </Row>
                                        <div className="mb-3">
                                            <Label htmlFor="formrow-message-Input">Message</Label>
                                            <Input
                                                type="textarea"
                                                className="form-control"
                                                id="formrow-message-Input"
                                                placeholder="Your message"
                                                style={{
                                                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                                                    color: "#fff",
                                                }}
                                            />
                                        </div>
                                        <div className="text-center">
                                            <Button
                                                type="submit"
                                                style={{
                                                    width: "100%",
                                                    fontWeight: "600",
                                                    background: "linear-gradient(to right, #6a11cb, #2575fc)",
                                                    border: "none",
                                                    padding: "10px 20px",
                                                    borderRadius: "25px",
                                                }}
                                                onMouseOver={(e) =>
                                                (e.target.style.background =
                                                    "linear-gradient(to right, #2575fc, #6a11cb)")
                                                }
                                                onMouseOut={(e) =>
                                                (e.target.style.background =
                                                    "linear-gradient(to right, #6a11cb, #2575fc)")
                                                }
                                            >
                                                Send
                                            </Button>
                                        </div>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>

                        {/* Right Column: Contact Details */}
                        <Col xl={6} lg={6} md={12}>
                            <Card
                                style={{
                                    background: "rgba(255, 255, 255, 0.1)",
                                    border: "none",
                                    borderRadius: "15px",
                                    padding: "20px",
                                }}
                            >
                                <CardBody>
                                    <h5
                                        className="text-center"
                                        style={{ fontWeight: "600", marginBottom: "20px" }}
                                    >
                                        Contact Details
                                    </h5>
                                    <p className="text-center">
                                        B/9, Ratnam Park, Nr Amin Party Plot, Gotri, Vadodara,
                                        Gujarat, India.
                                    </p>
                                    <p className="text-center">
                                        Email:{" "}
                                        <a
                                            href="mailto:aiinrealestate.in@gmail.com"
                                            style={{
                                                color: "#fff",
                                                textDecoration: "underline",
                                            }}
                                        >
                                            vivek.brahmbhatt@aiinrealestate.in, aiinrealestate.in@gmail.com
                                        </a>
                                    </p>
                                    <p className="text-center">
                                        Phone:{" "}
                                        <a
                                            href="tel:9586363303"
                                            style={{
                                                color: "#fff",
                                                textDecoration: "underline",
                                            }}
                                        >
                                            9586363303, 9879963303
                                        </a>
                                    </p>
                                    <div className="d-flex justify-content-center gap-4 mt-3">
                                        {/* Instagram */}
                                        <a
                                            href="https://www.instagram.com/aiinrealestate.in/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: "#fff",
                                                fontSize: "1.8rem",
                                            }}
                                        >
                                            <FaInstagram />
                                        </a>
                                        {/* Facebook */}
                                        <a
                                            href="https://www.facebook.com/aiinrealestate"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: "#fff",
                                                fontSize: "1.8rem",
                                            }}
                                        >
                                            <FaFacebookF />
                                        </a>
                                        {/* YouTube */}
                                        <a
                                            href="https://www.youtube.com/@aiinrealestate"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: "#fff",
                                                fontSize: "1.8rem",
                                            }}
                                        >
                                            <FaYoutube />
                                        </a>


                                        <a
                                            href="mailto:aiinrealestate.in@gmail.com"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: "#fff",
                                                fontSize: "1.8rem",
                                            }}
                                        >
                                            <FaEnvelope />
                                        </a>
                                        <a
                                            href="https://www.linkedin.com/in/aiinrealestate/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                color: "#fff",
                                                fontSize: "1.8rem",
                                            }}
                                        >
                                            <FaLinkedinIn />
                                        </a>
                                        {/* X (Twitter) */}
                                        <a
                                            href="https://x.com/aiinrealestate"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                fontSize: "1.8rem",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                width: "2.5rem",
                                                height: "2.5rem",
                                                color: "#fff",
                                                marginTop: "8px",
                                                // background: "linear-gradient(135deg, #000000, #434343)", // Bold and prominent gradient
                                                borderRadius: "20%",
                                                // boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.5)",
                                            }}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="white"
                                                stroke="white"
                                                strokeWidth="2"
                                                width="20px"
                                                height="20px"
                                            >
                                                <path d="M24 0L13.41 10.59 24 21.17 21.17 24 10.59 13.41 0 24V21.17L10.59 10.59 0 0H2.83L13.41 10.59 21.17 0H24z" />
                                            </svg>
                                        </a>

                                    </div>
                                    <div className="mt-4">
                                        <div
                                            id="map"
                                            style={{
                                                height: "300px",
                                                width: "100%",
                                                borderRadius: "15px",
                                                border: "2px solid #fff",
                                            }}
                                        ></div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Footer */}
            <Footer />
        </React.Fragment >
    );
};

export default Contactus;
